import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import PageHeader from '../../Shared/PageHeader';

const DevelopmentLayout = ({ 
  title, 
  categories = [], 
  selectedCategory, 
  onCategoryChange, 
  children 
}) => {
  return (
    <div>
      <div>
        <div className="pb-6">
          {/* Title */}
          <PageHeader icon={Sparkles} title={title} />

          {/* Category Navigation */}
          <div className="mb-8 max-w-full overflow-x-auto">
            <motion.div
              className="segmented"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.25, ease: 'easeOut' }}
            >
              {categories.map((category) => {
                const isActive = selectedCategory === category.id;
                return (
                  <button
                    key={category.id}
                    onClick={() => onCategoryChange(category.id)}
                    className={`segmented-item whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/60 ${isActive ? 'segmented-item-active' : ''}`}
                  >
                    <category.icon className={`h-4 w-4 ${isActive ? 'text-primary-600 dark:text-primary-400' : ''}`} />
                    <span>{category.label}</span>
                  </button>
                );
              })}
            </motion.div>
          </div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            {children}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentLayout;
